import { useState, useEffect } from 'react'
import { COUNTDOWN_INITIAL } from '../utils/constants'

// Global state outside the hook to synchronize all instances
let globalSeconds = COUNTDOWN_INITIAL
const listeners: Set<React.Dispatch<React.SetStateAction<number>>> = new Set()

// Single interval to drive all countdowns
setInterval(() => {
  if (globalSeconds > 0) {
    globalSeconds--
    listeners.forEach((setSeconds) => setSeconds(globalSeconds))
  }
}, 1000)

export function useCountdown() {
  const [seconds, setSeconds] = useState(globalSeconds)

  useEffect(() => {
    listeners.add(setSeconds)
    return () => {
      listeners.delete(setSeconds)
    }
  }, [])

  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60

  return {
    minutes: mins.toString().padStart(2, '0'),
    seconds: secs.toString().padStart(2, '0'),
    isExpired: seconds <= 0,
  }
}
